import axios from 'axios';

// Instância HTTP única do jornal. As leituras vão para caminhos SAME-ORIGIN
// (`/api/...`) que o proxy do front (`server/apiProxy`) repassa ao LICITACOES
// com o `Authorization: Bearer` anexado NO SERVIDOR. O navegador não obtém
// token nem credenciais — por isso aqui não há interceptors de autenticação.
//
// `baseURL: '/'` força caminhos absolutos a partir da raiz: um path relativo
// como `api/EditaisInternal/...` resolve para `/api/EditaisInternal/...`
// independentemente da rota atual da SPA.
export const api = axios.create({ baseURL: '/' });
